import { handleHttpRequest, http, type HttpResponse } from 'interfaces'
import {

  type LeadershipOfficer,
  type LegStaffInformation,
  transformAddress, transformRequestStaffer,
  transformResponseAddress
} from 'services'
import { type BulkAssignResult } from '../member/memberStaffService'
import { getEmptyPersonAddress, getEmptyStafferEmail } from 'helpers'

export interface LeadershipStaffInformation extends LegStaffInformation {
  leadershipOfficer: LeadershipOfficer
}

export async function retireStafferFromLeadership (legOfcId: number, stafferId: number): Promise<HttpResponse<void>> {
  return await handleHttpRequest(http.post(`/api/v1/us/leadership-officers/${legOfcId}/staff/${stafferId}/`))
}

export async function bulkAssignLeadershipOffice (legOfcId: number): Promise<HttpResponse<BulkAssignResult>> {
  const response = await http.post<HttpResponse<BulkAssignResult>>(
    `/api/v1/us/leadership-officers/${legOfcId}/bulk-assign/`
  )
  return response.data
}

export async function updateLeadershipStafferDisplayOrder (legOfcId: number, IdsAnddisplayOrders: Record<number, number>, selectedId: number, roleType: number): Promise<HttpResponse<[]>> {
  const payload = {
    idAndDisplayOrderMap: IdsAnddisplayOrders,
    selectedId,
    roleType
  }
  return await http.patch(`/api/v1/us/leadership-officers/${legOfcId}/staff/`, payload).then(response => response.data)
}

export async function getStaffByLeadership (legOfcId: number): Promise<LeadershipStaffInformation[]> {
  return await http.get(`/api/v1/us/leadership-officers/${legOfcId}/staff/`).then(response => {
    return response.data.map((data: any) => {
      return {
        ...data,
        email: data.email != null
          ? {
              id: data.email.id,
              value: data.email.value,
              personId: data.person.id,
              lastUpdated: data.email.lastUpdated,
              typeId: 1,
              descId: 1,
              displayOrder: data.email.displayOrder
            }
          : getEmptyStafferEmail(data.person.id),
        address: data.address != null
          ? {
              id: data.address.id,
              typeId: data.address.typeId,
              primary: transformAddress(data.address, 'primary'),
              secondary: transformAddress(data.address, 'secondary'),
              mailingAddress: data.address.mailingAddress,
              phones: data.address.phones,
              displayOrder: data.address.displayOrder,
              updatedBy: data.address.updatedBy,
              lastUpdated: data.address.lastUpdated
            }
          : getEmptyPersonAddress(data.person.id)
      }
    })
  })
}

export async function updateLeadershipStaffer (staffer: LeadershipStaffInformation): Promise<HttpResponse<LeadershipStaffInformation>> {
  const response = await http.put(
    `/api/v1/us/leadership-officers/${staffer.leadershipOfficer.id}/staff/${staffer.id}/`,
    transformRequestStaffer(staffer)
  )

  return {
    ...response.data,
    result: {
      ...response.data.result,
      address: transformResponseAddress(response.data.result.address)
    }
  }
}

export async function createLeadershipStaffer (staffer: LeadershipStaffInformation): Promise<HttpResponse<LeadershipStaffInformation>> {
  const response = await http.post(
    `/api/v1/us/leadership-officers/${staffer.leadershipOfficer.id}/staff/`,
    transformRequestStaffer(staffer)
  )

  return {
    ...response.data,
    result: {
      ...response.data.result,
      address: transformResponseAddress(response.data.result.address)
    }
  }
}
